import { Scope, captureException } from "@sentry/react";
import { CaptureContext } from "@sentry/types";

import { ResponseError } from "utility/response_error";

// -----------------------------------------------------------------------------

export function captureSentryExceptionUnless(
  error: unknown,
  scope: string,
  acceptableStatusCodes: number[]
): void;

export function captureSentryExceptionUnless(
  error: unknown,
  scope: string,
  throwIf: (error: unknown) => boolean
): void;

export function captureSentryExceptionUnless(
  error: unknown,
  scope: string,
  throwIf: () => boolean
): void;

export function captureSentryExceptionUnless(
  error: unknown,
  scopeFunction: (scope: Scope) => Scope,
  acceptableStatusCodes: number[]
): void;

export function captureSentryExceptionUnless(
  error: unknown,
  scopeFunction: (scope: Scope) => Scope,
  throwIf: (error: unknown) => boolean
): void;

export function captureSentryExceptionUnless(
  error: unknown,
  scopeFunction: (scope: Scope) => Scope,
  throwIf: () => boolean
): void;

export function captureSentryExceptionUnless(
  error: unknown,
  scopeOrScopeFunction: string | ((scope: Scope) => Scope),
  throwIfOrAcceptableStatusCodes?: number[] | ((error: unknown) => boolean)
): void {
  // (1) error is ResponseError
  // (2) throwIf is an array of numbers
  const statusCode = (error as ResponseError)?.status;
  const acceptableStatusCodes = throwIfOrAcceptableStatusCodes as number[];
  if (
    Array.isArray(acceptableStatusCodes) &&
    !acceptableStatusCodes.includes(statusCode)
  ) {
    return;
  }

  // (1) throwIf is a function
  const throwIf = throwIfOrAcceptableStatusCodes as (error: unknown) => boolean;
  if (typeof throwIf === "function" && !throwIf(error)) {
    return; // eslint-disable-line
  }

  //
  const scopeFunction = (
    typeof scopeOrScopeFunction === "function"
      ? scopeOrScopeFunction
      : (scope: Scope) => {
          scope.setTransactionName(scopeOrScopeFunction);

          //
          return scope;
        }
  ) as CaptureContext;

  //
  captureException(error, scopeFunction);
}
